import React, { useEffect, useState } from "react";
import BreadCrumbComp from "../../components/breadCrumb";
import TreatmentDetailsTab from "./treatmentDetails";
import MonthRegisterTab from "./monthRegister/index.js";
import RiskStatusTab from "./riskStatus/index.js";
import TabComponent from "../../components/tabComponent";
import { useLocation } from "react-router-dom";
import RiskDetailsTab from "./riskDetails/index.js";
import { formatDate } from "../../utils/dateUtils.js";
import { isActiveProcessByRole } from "./authorizeFxs.js";
import { useSelector } from "react-redux";
import {
  callApiAsync,
  getCallRisk,
  postUpdateRiskUpdateDate,
} from "../../services/apiService.js";
import HeaderBanner from "../../components/headerBanner/index.js";
import { headerBannerType } from "../../constants/enums.js";
import { months as monthsList } from "../../constants/selectData";
import { isRiskVersion } from "../../utils/riskAndOportunityVersion";

// rowData debe contener rmId (id de risk_month) para cargar el registro del mes correcto.
// La versión (v1/v2) se determina por risk.year y risk.month devueltos por getRisk.
const getRowData = (location) => {
  const state = location?.state;
  return state?.rowData ?? state ?? {};
};

const RiskDetails = () => {
  const userData = useSelector((state) => state.userData.userData);
  const [risk, setRisk] = useState(null);
  const location = useLocation();
  const rowData = getRowData(location);
  const [isEditionAvailable, setisEditionAvailable] = useState(false);
  const [isEditableMonthRegister, setIsEditableMonthRegister] = useState(false);

  const updateRiskupdateDate = async () => {
    const dataToSend = { riskId: risk.id, userId: userData.id };
    await callApiAsync(
      () => postUpdateRiskUpdateDate(dataToSend),
      () => {
        getRisk();
      }
    );
  };

  const getRisk = async () => {
    // Preferir rmId (risk_month id) para que getRisk devuelva el año/mes de ese registro y aplique la versión correcta.
    const riskId = rowData.rmId ?? rowData.id ?? "";

    if (!riskId) return;

    callApiAsync(
      () => getCallRisk(riskId),
      (data) => {
        setRisk(data);

        const version = isRiskVersion(data?.year, data?.month);

        const mayEditProcess = isActiveProcessByRole(
          userData.roleList,
          data.processId
        );
        setisEditionAvailable(mayEditProcess);
        setIsEditableMonthRegister(mayEditProcess);
      }
    );
  };

  useEffect(() => {
    getRisk();
  }, []);

  const tabData = [
    {
      name: "Detalles del Riesgo",
      id: "0",
      content: (
        <RiskDetailsTab
          data={risk}
          getRisk={getRisk}
          isEditionAvailable={isEditionAvailable}
          updateRiskupdateDate={updateRiskupdateDate}
        />
      ),
    },
    {
      name: "Detalles del Tratamiento",
      id: "1",
      content: (
        <TreatmentDetailsTab
          data={risk}
          getRisk={getRisk}
          isEditionAvailable={isEditionAvailable}
          updateRiskupdateDate={updateRiskupdateDate}
        />
      ),
    },
    {
      name: "Estatus del Riesgo",
      id: "2",
      content: (
        <RiskStatusTab
          data={risk}
          getRisk={getRisk}
          isEditionAvailable={isEditionAvailable}
          updateRiskupdateDate={updateRiskupdateDate}
        />
      ),
    },
    {
      name: "Registro por Mes",
      id: "3",
      content: (
        <MonthRegisterTab
          data={risk}
          getRisk={getRisk}
          isEditionAvailable={isEditableMonthRegister}
          updateRiskupdateDate={updateRiskupdateDate}
        />
      ),
    },
  ];

  return (
    <div>
      <BreadCrumbComp personalized={`RIESGOS - ${risk?.processName}`} />
      <HeaderBanner type={headerBannerType.riskAndOportunity} />
      <div className="gm-header">
        <div className="HContainer">
          <h1 className="gm-header-title-grey" style={{ marginRight: "15px" }}>
            N°: R-{risk?.risk_key} - {risk?.title}
          </h1>
          <h1 className="gm-header-title">{risk?.processName}</h1>
        </div>
        <div className="gm-header">
          <div className="j-space-between mb-10">
            <p className="lastC-text">Última Actualización:</p>
            <p className="li-item">
              {risk ? formatDate(risk?.updateDate) : ""}
            </p>
          </div>
          {risk?.year != null && risk?.month != null && (
            <div className="j-space-between mb-10">
              <p className="lastC-text ml-10">Mes de registro:</p>
              <p className="li-item">
                {monthsList.find((m) => m.value === risk.month)?.name ?? risk.month} {risk.year}
              </p>
            </div>
          )}
        </div>
      </div>
      <TabComponent panels={tabData}/>
    </div>
  );
};

export default RiskDetails;
